// i18n/consulting.js
export const heroConsultingText = {
  en: {
    small: "",
    main: "Leadership Development",
  },
  vi: {
    small: "",
    main: "Phát triển Lãnh đạo",
  },
};

// i18n/consulting.js
export const quoteConsultingText = {
  en: {
    desc: `Whether you’re an emerging leader or an experienced professional, our programs empower you to grow personally, lead strategically, and achieve your highest potential.`,
  },
  vi: {
    desc: `Dù bạn là nhà lãnh đạo mới hay chuyên gia giàu kinh nghiệm, chương trình của chúng tôi giúp bạn phát triển bản thân, dẫn dắt chiến lược và đạt được tiềm năng cao nhất.`,
  },
};

// i18n/leadership.js
export const consultsData = {
  en: [
    {
      id: 1,
      title: "Leadership & Personal Development",
      description: "Grow Yourself. Lead Others. Achieve More.",
      list: [
        "Great leaders are made, not born.",
        "Our Leadership & Personal Development programs help individuals unlock their full potential, build confidence",
        "and develop the skills to lead effectively, both personally and professionally.",
      ],
    },
    {
      id: 2,
      title: "What You Gain",
      description: "",
      list: [
        "Stronger Leadership Skills: Learn how to inspire, influence, and guide teams with confidence.",
        "Self-Mastery & Growth: Enhance decision-making, emotional intelligence, and resilience.",
        "Goal Achievement: Turn personal and professional goals into measurable results.",
        "Effective Communication: Build meaningful connections and lead with clarity and impact.",
        "Continuous Improvement: Develop habits and strategies for long-term success and fulfillment.",
      ],
    },
  ],

  vi: [
    {
      id: 1,
      title: "Phát triển Lãnh đạo & Cá nhân",
      description:
        "Phát triển bản thân. Dẫn dắt người khác. Đạt được nhiều hơn.",
      list: [
        "Những nhà lãnh đạo xuất sắc không phải sinh ra mà được rèn luyện. ",
        "Chương trình Phát triển Lãnh đạo & Cá nhân giúp bạn khai phá tiềm năng, xây dựng sự tự tin",
        "và phát triển kỹ năng lãnh đạo hiệu quả trong cả công việc và cuộc sống.",
      ],
    },
    {
      id: 2,
      title: "Bạn sẽ đạt được",
      description: "",
      list: [
        "Kỹ năng lãnh đạo vững vàng: Truyền cảm hứng, tạo ảnh hưởng và dẫn dắt đội ngũ tự tin.",
        "Làm chủ bản thân: Nâng cao tư duy quyết định, trí tuệ cảm xúc và khả năng thích ứng.",
        "Đạt mục tiêu: Biến mục tiêu cá nhân và nghề nghiệp thành kết quả cụ thể.",
        "Giao tiếp hiệu quả: Xây dựng kết nối và dẫn dắt với sự rõ ràng, sức ảnh hưởng.",
        "Phát triển bền vững: Hình thành thói quen và chiến lược cho thành công dài hạn.",
      ],
    },
  ],
};

export const leadershipCTA = {
  en: {
    text: "Ready to grow as a leader and unlock your full potential?",
    button1: "Start Your Leadership Journey →",
    button2: "",
  },
  vi: {
    text: "Sẵn sàng phát triển năng lực lãnh đạo và khai phá tiềm năng của bạn?",
    button1: "Bắt đầu hành trình lãnh đạo →",
    button2: "",
  },
};
